import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const RESET_PASSWORD_CLASS_NAME = 'ResetPassword';
export const RESET_PASSWORD_CLASS_SLOTS = ['root'] as const;

export type ResetPasswordClassSlot = typeof RESET_PASSWORD_CLASS_SLOTS[number];

export interface ResetPasswordClasses {
	root: string;
}

export type ResetPasswordClassKey = keyof ResetPasswordClasses;

export const getResetPasswordUtilityClass = (slot: string) =>
	generateUtilityClass(RESET_PASSWORD_CLASS_NAME, slot);

export const resetPasswordClasses = generateUtilityClasses<
	keyof ResetPasswordClasses
>(RESET_PASSWORD_CLASS_NAME, ['root']);
export default resetPasswordClasses;
